import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Checklist, Field, Loader } from '@itds/elements/index.js';

import Api from '@carrier/utils/Api';

const Permissions = ({ lifeDxProfile, relationship, saveRelationship }) => {
  const [products, setProducts] = useState([]);
  const [life_products, setLifeProducts] = useState([]);
  const [ltc_products, setLtcProducts] = useState([]);
  const [permissions, setPermissions] = useState(relationship.permissions || {});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Api.loadProducts({ carrier_id: relationship.carrier_id }).then(({ data }) => {
      setProducts(data);

      setLifeProducts(
        data.filter(p => {
          return ['Term', 'Term ROP', 'Whole Life', 'Final Expense', 'UL', 'IUL'].includes(p.product_type);
        })
      );

      setLtcProducts(data.filter(p => p.product_type === 'Long Term Care'));

      setLoading(false);
    });
  }, []);

  const handlePermissionsChange = (group, new_permissions) => {
    setPermissions({ ...permissions, [group]: new_permissions });
  };

  const handleSave = () => {
    saveRelationship({ permissions });
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      {lifeDxProfile.product_permissions.includes('life_quoting_api') && life_products.length ? (
        <Field
          description='Select which products you want this Partner to have access to. You can add and remove products at any time.'
          label='Life Quotes API'
        >
          <Checklist
            columns={3}
            onChange={handlePermissionsChange.bind(null, 'li_quotes')}
            options={life_products.map(p => ({ value: p.id, label: p.product_name }))}
            selected={permissions.li_quotes || []}
            showSelectAll={true}
          />
        </Field>
      ) : null}

      {lifeDxProfile.product_permissions.includes('ltc_quoting_api') && ltc_products.length ? (
        <Field
          description='Select which products you want this Partner to have access to. You can add and remove products at any time.'
          label='LTC Quotes API'
        >
          <Checklist
            columns={3}
            onChange={handlePermissionsChange.bind(null, 'ltc_quotes')}
            options={ltc_products.map(p => ({ value: p.id, label: p.product_name }))}
            selected={permissions.ltc_quotes || []}
            showSelectAll={true}
          />
        </Field>
      ) : null}

      {lifeDxProfile.product_permissions.includes('forms_api') && products.length ? (
        <Field
          description='Select which products you want this Partner to have access to. You can add and remove products at any time.'
          label='Forms API'
        >
          <Checklist
            columns={3}
            onChange={handlePermissionsChange.bind(null, 'forms')}
            options={products.map(p => ({ value: p.id, label: p.product_name }))}
            selected={permissions.forms || []}
            showSelectAll={true}
          />
        </Field>
      ) : null}

      <div style={{ marginTop: 30 }}>
        <Button inline={true} onClick={handleSave}>
          Save Changes
        </Button>
      </div>
    </>
  );
};

Permissions.propTypes = {
  lifeDxProfile: PropTypes.object,
  relationship: PropTypes.object,
  saveRelationship: PropTypes.func
};

export default Permissions;
